export function convert24HourTo12(time24) {
  if (!time24) return '12:00 PM';
  const [hours, minutes] = String(time24).slice(0, 5).split(':').map(Number);
  if (Number.isNaN(hours)) return '12:00 PM';

  const ampm = hours >= 12 ? 'PM' : 'AM';
  let hour12 = hours % 12;
  if (hour12 === 0) hour12 = 12;

  return `${hour12}:${String(minutes || 0).padStart(2, '0')} ${ampm}`;
}

/** Accepts either 24h (`15:30`) or 12h (`3:30 PM`) and returns normalized 12h display. */
export function to12HourDisplay(time) {
  if (!time) return '12:00 PM';
  const str = String(time).trim();
  const twelveHourMatch = str.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i)
    || str.match(/^(\d{1,2}):(\d{2})(AM|PM)$/i);
  if (twelveHourMatch) {
    const hour = parseInt(twelveHourMatch[1], 10);
    const minute = twelveHourMatch[2];
    const ampm = twelveHourMatch[3].toUpperCase();
    return `${hour}:${minute} ${ampm}`;
  }
  return convert24HourTo12(str);
}

export function convert12HourTo24(time12) {
  if (!time12) return '00:00';
  const trimmed = String(time12).trim();
  const match = trimmed.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i)
    || trimmed.match(/^(\d{1,2}):(\d{2})(AM|PM)$/i);
  if (!match) return '00:00';

  let hour = parseInt(match[1], 10);
  const minute = parseInt(match[2], 10);
  const ampm = match[3].toUpperCase();

  if (ampm === 'PM' && hour !== 12) hour += 12;
  else if (ampm === 'AM' && hour === 12) hour = 0;

  return `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
}

export function extractTimeFromDatetime(datetimeStr, fallback = '12:00 PM') {
  if (!datetimeStr) return fallback;
  const str = String(datetimeStr);
  if (!str.includes(' ') && !str.includes('T')) return fallback;

  const timePart = str.split(/[\sT]/)[1];
  if (!timePart) return fallback;

  const time24 = timePart.substring(0, 5);
  if (!/^\d{2}:\d{2}$/.test(time24)) return fallback;

  return convert24HourTo12(time24);
}

export function datetimeHasSpecificTime(datetimeStr) {
  if (!datetimeStr) return false;
  const str = String(datetimeStr);
  if (!str.includes(' ') && !str.includes('T')) return false;

  const timePart = str.split(/[\sT]/)[1];
  if (!timePart) return false;

  const [hours, minutes] = timePart.substring(0, 5).split(':').map(Number);
  return !(hours === 0 && (minutes || 0) === 0);
}

export function toDateOnlyString(dateValue) {
  if (!dateValue) return '';
  const str = String(dateValue);
  if (/^\d{4}-\d{2}-\d{2}$/.test(str)) return str;
  if (str.includes(' ') || str.includes('T')) return str.slice(0, 10);
  const parsed = new Date(dateValue);
  if (Number.isNaN(parsed.getTime())) return str.slice(0, 10);
  const y = parsed.getFullYear();
  const m = String(parsed.getMonth() + 1).padStart(2, '0');
  const d = String(parsed.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function buildTaskDatetime(dateOnly, time12, shouldApplyTime) {
  const dateStr = toDateOnlyString(dateOnly);
  if (!dateStr) return '';

  if (!shouldApplyTime || !time12) {
    return `${dateStr} 00:00:00`;
  }

  const time24 = convert12HourTo24(time12);
  return `${dateStr} ${time24}:00`;
}

export function taskUsesSameDayTimes(startDateOnly, endDateOnly) {
  return Boolean(startDateOnly && endDateOnly && startDateOnly === endDateOnly);
}
